// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestFilledSvg from "@ant-design/icons-svg/es/asn/RestFilled";
import AntdIcon from '../components/AntdIcon';

var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestFilledSvg
  }));
};

RestFilled.displayName = 'RestFilled';
export default /*#__PURE__*/React.forwardRef(RestFilled);